import axios from "axios";

export const deleteLeague = async (id, token) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_API_URL_USER}/leagues/deleteLeague/${id}`,

      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    if (error.response) {
      // throw new Error(error.response?.data?.message);
      return error.response?.data?.message;
    }
    if (error.request) {
    }
    // throw new Error(error.message);
    return error.message;
  }
};
